import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Button , Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Typography } from '@mui/material';
import Lables from '../../components/translations/translation.json'
//css file
import './emailModal.css';

import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function EmailModal(props) {
  const [open ] =  useState(true);
  const [close] =  useState(true);

  console.log("new email id",props.emailId);

  const handleClose = () => {
    props.callback(false);
  }

  const handleInfoClose = () => {
      props.callbackInfoClose();
  }

  const handleUpdateEmail = () => {
    props.callbackUpdateEmail();
  }
  
  const handleDeleteEmail = () => {
    props.callbackDeleteEmail();
  }

  return (
   <>
      <Dialog  style={{cursor: 'move'}} PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title" className='dialog-modal' open={open}> 
      <DialogTitle className="dialogTitle-emailModalMain" id="draggable-dialog-title" sx={{ m: 0, p: 2 }}>                                                        
      {Lables[props.langProp].CONFORMATION_MODAL}
          { close ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: '#000',
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}                             
      </DialogTitle> 
      <DialogContent dividers className="dialog-content">                    
          <DialogContentText className="dialog-content-text"> 
          { props.modalUpdateState ?
            <>
            <p className='textBody-emailModal'>{Lables[props.langProp].VALID_EMAIL_MODAL}  {props.emailId}.
            <br/>
            
           {Lables[props.langProp].UPDATE_EMAIL_MODAL}</p> 
            </>
            : "" } 
            { props.modalDeleteState ?
              <>
             <p  className='textBody-emailModal'>{Lables[props.langProp].DELETE_EMAIL_PARA1}
             <br/>
             <br/> 
              {Lables[props.langProp].DELETE_EMAIL_PARA2}
              </p> 
             </>
               : 
              ""}    
          </DialogContentText>                           
      </DialogContent>
      <DialogActions>                
      { props.modalUpdateState ? 
        <>
        <Button variant="contained" className="button-ok-emailModalMain" onClick={handleUpdateEmail}>{Lables[props.langProp].OK}</Button>
        <Button variant="contained" onClick={handleClose} className="button-ok-emailModalMain">{Lables[props.langProp].CANCEL}</Button> 
        </> 
        :
        ""}
        { props.modalDeleteState ?
        <>
        <Button variant="contained" className="button-ok-emailModalMain" onClick={handleDeleteEmail}>{Lables[props.langProp].OK}</Button>
        <Button variant="contained" className="button-ok-emailModalMain" onClick={handleClose}>{Lables[props.langProp].CANCEL}</Button>
        </>
        : ""
      }
      </DialogActions>
    </Dialog>
  </>
  );
}

EmailModal.propTypes = {
  langProp: PropTypes.string,
  emailId: PropTypes.string,
  callback: PropTypes.func,
  callbackInfoClose: PropTypes.func,
  callbackUpdateEmail: PropTypes.func,
  callbackDeleteEmail: PropTypes.func,
  modalUpdateState: PropTypes.bool,
  modalDeleteState: PropTypes.bool,
};

export default EmailModal;